





































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {MailNotifyDetailItemInfo} from "@/store/mailnotify/statistic/types";
import { colorClassByStatus } from "@/utils/page-utils";
import {dateFilter} from "@/utils/date-util";
import {notifyError} from '@/utils/notify-helper';

@Component({
  filters: {dateFilter},
  methods: {colorClassByStatus}
})
export default class MailNotifyDetailInfo extends Vue {
  @Action("getMNStatisticDetailInfo") actionGetStatisticDetailInfo: any;

  defaultInfo(): MailNotifyDetailItemInfo {
    return {
      recipient: "",
      country: "",
      originator: "",
      message_parts: null,
      message: "",
      status: "",
      partner_user_login: "",
      id: "",
      partner_price: null,
      operator: "",
      broker_account_login: null,
      template_id: null,
      bulk_id: null,
      sent_date: null,
      connection_type: null,
    };
  }

  private messageInfo = this.defaultInfo();

  async created() {
    if (this.$route.params.id) {
      try {
        const resp = await this.actionGetStatisticDetailInfo(this.$route.params.id);
        this.messageInfo = Object.assign({}, this.messageInfo, resp.data);
      } catch(error) {
        notifyError(error);
      }
    }
  }

  back(): void {
    this.$router.push('/report/detailed/mail_notify');
  }

}
